import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&:not([class=*"expandedRowEditMode"]) td': {
      backgroundColor: idsTokens.table.default.tableCell.color.text.background.enabled,
    },
    '&:not(.MuiTableRow-head, .MuiTableRow-footer)': {
      backgroundColor: idsTokens.table.default.tableCell.color.text.background,
    },
    '& td:first-of-type': {
      border: 'none',
    },
    borderTop: `${idsTokens.table.default.tableCell.border.text.stroke} solid ${idsTokens.table.default.tableCell.border.text.color.enabled}`,
    '&:first-of-type': {
      border: 'none',
    },
    '&.MuiTableRow-hover:hover': {
      backgroundColor: idsTokens.table.default.tableCell.color.text.background.hover,
      '& td': {
        color: idsTokens.table.default.tableCell.color.text.label.hover,
      },
    },
    'tbody &:not(:last-child) td:first-of-type::before': {
      content: '""',
      display: 'block',
      backgroundColor: idsTokens.table.default.tableCell.color.text.background,
      position: 'absolute',
      left: 0,
      top: '100%',
      width: 15,
      height: 1,
    },
  },
  head: {
    height: 40,
  },
});
